import { UserMgr } from './mgrs/UserMgr'

export class Controller {
  static _me = null;
  static get() {
    if (this._me == null) {
      this._me = new Controller();
    }
    return this._me;
  }

  constructor() {
  }

  _userMgrObj = null;
  userMgr() {
    if (null == this._userMgrObj) {
      this._userMgrObj = new UserMgr();
    }
    return this._userMgrObj;
  }

  setNavigator(history) {
    this.history = history
  }

  pushRouteWithParams(route, params) {
    this.history.push({ pathname: route, state: params })
  }

  pushRoute(route) {
    this.history.push(route)
  }

  pushRouteBack() {
    this.history.goBack()
  }
}



// WEBPACK FOOTER //
// ./src/common/Controller.js